module.exports = "/virtual-football-league/img/amblems/right/logos/Chelsea.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Chelsea.png
// module id = 2167
// module chunks = 4